import { render, staticRenderFns } from "./ReportModalSignPhysician.vue?vue&type=template&id=ff4f34ec&scoped=true&"
import script from "./ReportModalSignPhysician.vue?vue&type=script&lang=js&"
export * from "./ReportModalSignPhysician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4f34ec",
  null
  
)

export default component.exports